import React from 'react'

export default function Support() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 items-center mb-20">
   
    <main className="mt-5 mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-8 lg:mt-10 lg:px-8 xl:mt-18">
             <div className="sm:text-center ">
               <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-3xl md:text-4xl">
                 <span className="block xl:inline">Chatea con los expertos</span>{' '}
                 <span className="block text-cyan-600 xl:inline">Budgie Cuba</span>
               </h1>
 
 
               <h1 className="text-2xl tracking-tight font-medium text-gray-900 sm:text-1xl md:text-2xl mt-5">
                 <span className="block xl:inline">Siempre dispuesto a dar el mejor de los servicios.</span>
                
               </h1>
               <p className="mt-2 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl ">
               Para poder ayudarte mejor, contáctanos desde tu teléfono vía Whatsapp. +5359112215.             
               </p>
               <p className="mt-2 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl ">
               Escribenos a nuestro correo electrónico. amatamoros921029@gmail.com
               </p>            
 
 
              
              
           
             </div>
           </main>
   
     </div>
  )
}
